import { getServerOrClientCookies } from "@/lib/utils/cookies"

/**
 * Helper util to check if the current page is being rendered inside a Farcaster frame.
 *
 * The middleware sets a cookie when the page is being rendered inside a frame.
 */
export async function isInFrame() {
  const cookie = await getServerOrClientCookies("frame")

  console.log("isInFrame", cookie)

  return !!cookie
}
